<template>
	<div class="h_wk">
		<h1 class="h1">王者荣耀在线估值</h1>
		
		<div class="search-box">
			<input type="text" class="search-input" placeholder="请输入用户ID" v-model="userid"/>
			<button class="search-btn" @click="getUserAdapter()">{{loading?'加载中':'确定'}}</button>
		</div>
		
		<div class="detail-input">
			<div class="detail-input-item"><input type="text"  placeholder="请输入编号" v-model="code"></div>
			<div class="detail-input-item"><input type="number" placeholder="请输入荣耀水晶" v-model="rysj"></div>
		</div>
		<div style="display: flex;align-items: center;justify-content: center;flex-wrap: wrap;margin: 10px auto;" v-if="detail" >
			<div class="w_main_s_y_x_li" v-for="(skin,skinidx) in starList" :key="(skin.iSkinId+'_'+skinidx)" @click="selectStar(skin)">
				<div class="w_main_s_y_x_li_s">
					<img class="w_main_s_y_x_li_szs" src="../images/w_zss.png">
					<img class="w_main_s_y_x_li_sp" :src="getImage(skin.szSmallIcon)">
					<img class="w_main_s_y_x_li_xzs" src="../images/w_zsx.png">
					<img src="../images/xuanzhong.png" v-if="skin.selected==1" style="position: absolute;z-index: 1;width: 30px;height: 30px;right: 0;bottom: 0;">
				</div>
				<div class="w_main_s_y_x_li_x">
					{{skin.szTitle}}.{{skin.szHeroTitle}}
				</div>
			</div>
		</div>
		
		<div style="position: fixed;z-index: 10000;right: 20px;top: 20%;" v-if="detail">
			<div class="btn-item" @click="createCheck()">{{showCreateLoading?'生成中':'生成图片'}}</div>
			<div class="btn-item"><colorPicker v-model="color"></colorPicker></div>
		</div>
	
		<div class="w_wk" v-if="detail" ref="capture" :style="bodyColor">
			<div class="w_main">
				<div class="w_main_s clearfix">
					<div class="w_main_s_y_s clearfix" v-show="showShuiyin">
						<div class="w_main_s_y_s_logo fl" style="margin-bottom: 20px;">

            </div>
						<div class="w_main_s_y_s_hx fl">

						</div>
						<div class="w_main_s_y_s_qn fr" v-if="detail.qq.qq_wzry">
							{{detail.qq.qq_wzry}}
						</div>
					</div>
					<div class="w_main_s_z">
						<div class="w_main_s_z_bt" v-show="showShuiyin"><img src="../images/w_logo.png"></div>
						<div class="w_main_s_z_nr">
							<div class="w_main_s_z_nr_li">
								编号：{{code}}
							</div>
				
				
							<div class="w_main_s_z_nr_li">
								区服：{{detail.battlerProfile.rolecard.areaServerText}}
							</div>
							<div class="w_main_s_z_nr_li" v-for="item in detail.battlerProfile.battleCard.list" :key="item.name">
								{{item.name}}：{{getValue(item.value)}}
							</div>
							
							<div class="w_main_s_z_nr_li">
								游戏段位：{{detail.battlerProfile.battleCard.title}}
							</div>
							<div class="w_main_s_z_nr_li">
								贵族等级：{{detail.battlerProfile.rolecard.nobilityLevel}}
							</div>
							<div class="w_main_s_z_nr_li">
								荣耀水晶：{{rysj||0}}
							</div>
						</div>
					</div>
					
				</div>
				
				<div v-if="skinData" :style="backgroundStyle">
					<div v-for="item in skinData" :key="item.classTypeName">
						<div v-if="item.count>0">
							<div class="w_main_title">{{item.classTypeName}}</div>
							<div class="w_main_x" style="margin-top: 20px;">
								<draggable v-bind="item.list" style="z-index: 1;">
									<transition-group name="flip-list" style="display: flex;flex-wrap:wrap;">
										<div class="w_main_s_y_x_li" v-for="(skin,skinidx) in item.list" :key="(skin.iSkinId+'_'+skinidx)">
											<div class="w_main_s_y_x_li_s">
												<img class="w_main_s_y_x_li_szs" src="../images/w_zss.png">
												<img class="w_main_s_y_x_li_sp" :src="getImage(skin.szSmallIcon)">
												<img class="w_main_s_y_x_li_xzs" src="../images/w_zsx.png">
											</div>
											<div class="w_main_s_y_x_li_x">
												{{skin.szTitle}}.{{skin.szHeroTitle}}
											</div>
										</div>
									</transition-group>
								</draggable>
								
							</div>
						</div>
						
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
import {getUserAdapter} from "../server";
import html2canvas from "html2canvas";
import draggable from "vuedraggable";
import { getStorageSync,Falert } from "../unitl/common";
import { constant } from "../unitl/constant";
var browser = {
    versions: (function() {
        var u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") > -1, //是否微信
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
export default {
    name: "Wzry4",
    data() {
        return {
            token:'',
			openid:"",
			gameid:'',
			roleList:[],
			loading:false,
			showCreateLoading:false,
			showShuiyin:true,
			bg:'',
			qq:{},
			userid:'',
			detail:null,
			rysj:'',
			code:'',
			level:'',
			skinData:null,
			color:'',
			starList:[]
        };
    },
	computed:{
		
		bodyColor(){
			if(this.color){
				return {background:this.color};
			}
			return{};
		},
		backgroundStyle(){
			var backgroundImg='';
			var backgroundRepeat='';
			var bg=require('../assets/bg4.png');
			
			if(this.showShuiyin){
				backgroundImg=`url(${bg})`;
				backgroundRepeat='repeat-y';
			}

			let style={
				backgroundImage:backgroundImg,
				backgroundRepeat:backgroundRepeat,
				backgroundSize:'100%'
			}
			return style;
		}
	},
	components: {
		draggable
	},
    watch: {
        pageIndex(val) {
            this.loadBackgounds(val);
        }
    },
    methods: {
		selectStar(skin){
			if(skin.selected==0){
				skin.selected=1;
			}else{
				skin.selected=0;
			}
			var skinData=this.skinData;
			var key='1_0';
			if(skin.selected==1){
				skinData[key].count+=1;
				skinData[key].list.push(skin);
			}else{
				skinData[key].count-=1;
				for(var i=0;i<skinData[key].list.length;i++){
					if(skinData[key].list[i].iSkinId==skin.iSkinId){
						skinData[key].list.splice(i,1);
						break;
					}
				}
			}
			this.skinData=skinData;
			
		},
		getImage(src){
			return src.replace('shp.qpic.cn','wzry-images.weilaiwangluo.com/tgos');
		},
		createCheck(){
			if(!this.code){
				Falert('请输入编号');
				return;
			}
			this.createImg();
		},
		getValue(value){
			return value.toString().split('/')[0];
		},
		createImg() {
			this.showCreateLoading = true;
			let rect = this.$refs.capture.getBoundingClientRect();
			const rate = 4000 / rect.height;
			if (
				rate < 1 &&
				(browser.versions.mobile ||
					browser.versions.ios ||
					browser.versions.android ||
					browser.versions.iPhone ||
					browser.versions.iPad)
			) {
				this.$refs.capture.style.transform = `scale(${rate})`;
				rect = this.$refs.capture.getBoundingClientRect();
			}
	
			const scrollTop =
				document.documentElement.scrollTop || document.body.scrollTop;
			html2canvas(this.$refs.capture, {
				imageTimeout: 1000000,
				useCORS: true,
				allowTaint: true,
				x: Math.round(rect.x+(browser.versions.mobile?0:this.htmlCanvasAdjustX)),
				y: Math.round(rect.y),
				scrollY: -scrollTop,
				width: Math.round(rect.width-(browser.versions.mobile?0:this.htmlCanvasAdjustWidth)),
				height: Math.round(rect.height)
			}).then(canvas => {
				// 通过a标签下载到本地
				let link = document.createElement("a");
				link.href = canvas.toDataURL("image/jpeg");
				link.setAttribute("download", '王者荣耀_'+Date.now() + ".jpg");
				link.style.display = "none";
				document.body.appendChild(link);
				link.click();
				this.showCreateLoading = false;
				this.$refs.capture.style.transform = `scale(1)`;
			});
	
		},
		getSkinData(){
			return{
				'1_1':{
					classTypeName: "荣耀典藏",
					count:0,
					list:[]
				},
				'1_0':{
					classTypeName: "星传说",
					count:0,
					list:[]
				},
				'1_2':{
					classTypeName: "传说",
					count:0,
					list:[]
				},
				'1_3':{
					classTypeName: "史诗",
					count:0,
					list:[]
				},
				'1_4':{
					classTypeName: "勇者",
					count:0,
					list:[]
				},
				'1_5':{
					classTypeName: "限定",
					count:0,
					list:[]
				},
				'1_1000':{
					classTypeName: "其他",
					count:0,
					list:[]
				}
			}
		},
		
		getUserAdapter(){
			if(!this.userid){
				Falert('请输入用户ID');
				return;
			}
			if(this.loading){
				Falert('正在加载数据，请稍后');
				return;
			}
			this.loading=true;
			this.skinData=null;
			this.detail=null;
			getUserAdapter({userid:this.userid}).then(res=>{
				this.starList=res.starList;
				this.detail=res;
				var skinTypeList=res.skinInfo.skinCountInfo.skinTypeList;
				var skinType={};
				for(var i=0;i<skinTypeList.length;i++){
					var item =skinTypeList[i];
					skinType[item.classType.toString()]=item;
				}
				
				var skinData=this.getSkinData();
				var heroSkinList=res.skinInfo.heroSkinList;
				var heroSkinConfList=res.skinInfo.heroSkinConfList;
			
				
				for(var j=0;j<heroSkinList.length;j++){
					
					var skin=heroSkinConfList[heroSkinList[j]['skinId']];
					if(!skin){
						console.log(heroSkinList[j]);
						continue;
					}
					var classType=skin.classType?skin.classType[0]:'1000';
					if(!skinData['1_'+classType]){
						if(skinType[classType].classTypeName.indexOf('限定')!=-1){
							classType='5';
						}else{
							classType='1000';
						}
					}
					if(skin.szHeroTitle=='瑶'){
						// console.log(skin);
					}
					skinData['1_'+classType].count+=1;
					skinData['1_'+classType].list.push(skin);
				}
				this.$nextTick(()=>{
					this.skinData=skinData;
				})
				var userInfo=JSON.parse(getStorageSync(constant.userInfo)||'{}');
				if(userInfo&&userInfo.shuiyin){
					this.showShuiyin=false;
				}
				this.loading=false;
			})
		}
    },

    mounted() {
		const meta = document.createElement('meta');
		meta.content = 'never';
		meta.name = 'referrer';
		document.getElementsByTagName('head')[0].appendChild(meta);
    }
};
</script>

<style scoped>
	.btn-item .m-colorPicker {
		width: 100%;
		height: 100%;
		display: flex !important;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.btn-item .m-colorPicker::before {
		content: "选择背景颜色";
		padding-right: 7px;
		color: #fff;
	}
.preview{
	display: flex;
	flex-wrap:wrap;
	/* justify-content: center; */
}
.flip-list-move {
    transition: transform 0.5s;
}
h1 {
    margin-top: 80px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
}
.tips {
    padding-left: 20px;
    margin: 19px auto 0;
    width: 70px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(65, 194, 131, 1);
    line-height: 28px;
    background: url("../assets/green.png") left center no-repeat;
}
.search-box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 60px;
}
.search-input {
    width: 510px;
    height: 46px;
    background: rgba(198, 212, 223, 1);
    border: none;
    outline: none;
    text-indent: 20px;
}
.search-input::placeholder {
    color: #869199;
}
.search-btn {
    width: 120px;
    height: 46px;
    background: rgba(44, 82, 129, 1);
    border: none;
    outline: none;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
}

.detail-input{
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	width: 1000px;
	margin: 10px auto;
	justify-content: center;
	
}

.detail-input-item{
	width: 32%;
	margin-right: 1%;
	height: 46px;
	margin-top: 10px;
	padding:0 5px;
	background: rgba(198, 212, 223, 1);
	position: relative;
}
.detail-input-item input{
	height: 46px;
	width: 100%;
	background: rgba(198, 212, 223, 1);
	border: none;
	outline: none;
	color: #000;
	
}
.detail-input-item input::placeholder {
    color: #666;
}
.h1{
	margin-top: 40px;
}
.loading-show{
    margin-top: 30px;
    color: #ffffff;
	font-size: 20px;
}


.btn-item {
    color: #fff;
    border-radius: 4px;
	padding:5px 10px;
    width: 130px;
    text-align: center;
    background: rgba(44, 82, 129, 1);
    margin: 10px;
    cursor: pointer;
}

@charset "utf-8";

/* CSS Document */
* {
	font-family: "微软雅黑";
	outline: none;
	font-size: 14px;
	color: #444444;
	list-style: none;
	line-height: 26px;
}

* {
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

body, dl, dd, h1, h2, h3, h4, h5, h6, from {
	margin: 0;
}

img {
	max-width: 100%;
	display: block;
}

ol, ul, li, img {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	vertical-align: baseline;
}

input, img, textarea {
	border: none;
	border-radius: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

a {
	text-decoration: none;
	blr: expression(this.onFocus=this.blur()); /* IE Opera */
	outline: none; /* FF Opera */
}

a:focus {
	-moz-outline-style: none; /* FF */
}

img, input {
	border: 0;
}

input, textarea, select {
	outline: none;
}

a div, a span {
	cursor: pointer;
}

textarea {
	resize: none;
}

/*闃叉textarea鏀惧ぇ鏃讹紝涓変釜鏂滅嚎琚斁澶?*/
*, *:before, *:after {
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	-o-box-sizing: border-box;
}

html, body, ul, li, a, span, p {
	padding: 0;
	margin: 0;
	list-style: none;
	line-height: 22px;
	margin: 0px;
	padding: 0px
}

img {
	border: 0px;
}

.juzhong {
	width: 1250px;
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.lfd {
	float: left;
	display: block;
}

.rfd {
	float: right;
	display: block;
}

h2, h3, h4, h5 {
	text-align: center;
}

p {
	font-family: "微软雅黑";
	line-height: 26px;
}

.gg {
	width: 1200px;
	margin-left: auto;
	margin-right: auto;
}

.clear {
	clear: both;
}

.clearfix:after {
	visibility: hidden;
	display: block;
	font-size: 0;
	content: " ";
	clear: both;
	height: 0;
}

.clearfix {
	*zoom: 1;
}

.fl {
	float: left;
}

.fr {
	float: right;
}

/* 王者荣耀样式开始 */
.w_wk {
	width:auto;
	background: url('../images/wbg.jpg');
	background-repeat: no-repeat;
	background-position: center top;
	background-attachment: fixed;
	min-height: 1080px;
	background-size: 100% 100%;
	margin: 10px auto;
}

.w_main {
	width: 1200px;
	margin: 0px auto;
	padding: 50px 0;
	overflow: hidden;
}

.w_main_s_z {
	background: url('../images/w_bk.png');
	position: relative;
	background-size: 100% 100%;
}

.w_main_s_z_bt {
	position: absolute;
	left: 50%;
	top: -18px;
	transform: translate(-50%, 0);
}

.w_main_s_z_nr {
	padding-top: 60px;
	margin-left: 60px;
	margin-right: 60px;
	display: flex;
	flex-wrap: wrap;
}

.w_main_s_z_nr_li {
	margin-bottom: 20px;
	font-size: 20px;
	color: #fff;
	font-weight: bold;
	padding: 5px 0;
	line-height: 32px;
	text-align: center;
	width: 25%;
}

.w_main_s_y {
	width: 1300px;
	overflow: hidden;
}

.w_main_s_y_s_hx {
	padding-top: 28px;
	margin-left: 50px;
}

.w_main_s_y_s_qn {
	background: url('../images/w_btnbg.png');
	width: 334px;
	height: 64px;
	font-size: 24px;
	line-height: 24px;
	color: #fff;
	font-weight: bold;
	text-align: center;
	padding-top: 14px;
	box-sizing: border-box;
	margin-top: 20px;
}
.w_main_x{
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: start;
}
.w_main_title{
	color: #fff;
	padding: 10px 0;
	font-size: 30px;
	margin: 20px 0;
	text-align: center;
}
.w_main_s_y_x_li {
	width: 280px;
	margin:10px;
	/* height: 270px; */
}

.w_main_s_y_x_li_s {
	width: 100%;
	border-radius: 16px;
	position: relative;
	margin: 0 auto;
}

.w_main_s_y_x_li_szs {
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0);
	top: -7px;
}

.w_main_s_y_x_li_xzs {
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0);
	bottom: -7px;
}

.w_main_s_y_x {
	padding-top: 40px;
	width: 1350px;
}

.w_main_s_y_x_li_sp {
	width: 100%;
	height: 425px;
	border-radius: 16px;
	object-fit: cover;
	border: 2px solid #927148;
}

.w_main_s_y_x_li_x {
	text-align: center;
	font-size: 15px;
	color: #fff;
	margin-top: 10px;
/* 	background-image: -webkit-linear-gradient(bottom, #aabed6, #ffffff, #aabed6);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent; */
}





</style>
